import React, { useEffect, useRef } from 'react';
import parse from 'html-react-parser';

export interface TooltipProps {
  tooltipData: string
}

const CardTooltip = (props: TooltipProps) => {
	const { tooltipData } = props;
	const tooltipRef = useRef<HTMLDivElement | null>(null);

	useEffect(() => {
		const tooltipElement = tooltipRef.current;

		const handleMouseEnterOrTouchStart = (e: Event) => {
			e.stopImmediatePropagation();

			const target = e.target as HTMLElement;
			const parentNode = target.closest('.text-content');

			if (target && tooltipElement && parentNode) {
				const left = target.offsetLeft;
				const { width, height } = target.getBoundingClientRect();

				tooltipElement.style.left = left + width / 2 + 'px';
				tooltipElement.style.bottom = -target.offsetTop + height + 'px';
				tooltipElement.classList.add('isVisible');
			}
		};

		const handleMouseLeaveOrTouchEnd = (e: Event) => {
			e.stopImmediatePropagation();
			tooltipElement?.classList.remove('isVisible');
		};

		const tooltipTargets = document.querySelectorAll('[data-tooltip]') || [];

		tooltipTargets.forEach(target => {
			target.addEventListener('mouseenter', handleMouseEnterOrTouchStart, false);
			target.addEventListener('touchstart', handleMouseEnterOrTouchStart, false);
			target.addEventListener('mouseleave', handleMouseLeaveOrTouchEnd, false);
			target.addEventListener('touchend', handleMouseLeaveOrTouchEnd, false);
		});

		return () => {
			tooltipTargets.forEach(target => {
				target.removeEventListener('mouseenter', handleMouseEnterOrTouchStart, false);
				target.removeEventListener('touchstart', handleMouseEnterOrTouchStart, false);
				target.removeEventListener('mouseleave', handleMouseLeaveOrTouchEnd, false);
				target.removeEventListener('touchend', handleMouseLeaveOrTouchEnd, false);
			});
		};
	}, []);

	return (
		<div className="lhp-tooltip" ref={ tooltipRef }>
			<div className="arrow" />
			{ parse(tooltipData) }
		</div>
	);
};

export default CardTooltip;
